// export const BACKEND_SERVER_URL = "http://localhost:8005";


// export const BASE_URL = "http://localhost:8005";
export const BASE_URL = "https://node.insightdelhi.com";